module.exports = __webpack_public_path__ + "img/al-reem.80a9ec6.webp";